export const enableDarkThemeForWebApp = () => {
  document.documentElement.style.setProperty('--openInOneNoteBannerColor','#272727')
  document.documentElement.style.setProperty('--openInOneNoteBorderColor','#3D3D3D')
  document.documentElement.style.setProperty('--oneNotePurple','#C0AAE4')
  document.documentElement.style.setProperty('--openInOneNoteBannerTextOnHoverColor','#CEBBED')
  document.documentElement.style.setProperty('--n-image-footer-icon-color','#C0AAE4')
  document.documentElement.style.setProperty('--n-close-button-color', '#272727')
}
